import { IEntity, Entity, IEntityWithCustomer, EntityWithCustomer } from "./Entity";

export interface IBaseCustomFieldDfns extends IEntityWithCustomer { 
    Display?: boolean;
}

export class BaseCustomFieldDfns extends EntityWithCustomer implements IBaseCustomFieldDfns {
}